/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component, useState, useEffect } from 'react' // eslint-disable-line

import { Drawer, Button, Form, Spin, Select, Input, message } from 'antd'

import { shopAction } from '../../action/shop'

import { listLoader } from '../../store/list/ListLoader'
import { ViewerStyles, EditorStyles } from './styles'

const FIELDS_LIST = [
  ['shelf_code', '货架编号'],
  ['machine_id', '机器编号'],
  ['sequence', '序号'],
  ['status', '状态', {
    type: 'select',
    default: 1,
    options: [[0, '不显示'], [1, '显示']],
  }],
]

interface Props {
  text: string
  icon: string
  record: any
}

const buildFormItem = (key: any, config: any) => {
  if (config[2] && config[2].type === 'select') {
    return <Select
      value={config[2].default}
    >
      {
        config[2].options.map((item: any) => {
          return <Select.Option value={item[0]}>{item[1]}</Select.Option>
        })
      }
    </Select>
  }
  return <Input placeholder={`Input ${key}`} />
}

const ShelfAddMachineFormInner = (props: any) => {
  // const formData = props.formData
  const { getFieldDecorator, setFieldsValue } = props.form

  const onSubmitCreate = (e: Event) => {
    e.preventDefault()
    props.form.validateFields((err: any, values: any) => {
      if (err) {
        console.log('Received values of form: ', values)
        return
      }
      props.onSubmit(values, (data: any) => {
        setFieldsValue(data)
      })
    })
  }

  return <Form layout="vertical" css={EditorStyles['edit-form']} onSubmit={onSubmitCreate}>
    <Form.Item label="" css={EditorStyles["edit-label-title"]}>
      <span className="ant-form-text">添加机器</span>
    </Form.Item>
    {
      FIELDS_LIST.map((item: any) => {
        const key = item[0]
        return (
          <Form.Item
            key={key}
            label={
              <span css={EditorStyles['edit-label']}>
                <span className="label-title">{item[0]}:</span>
                <span css={EditorStyles['edit-label-hint']}>{item[1]}</span>
              </span>
            }
          >
            <div css={EditorStyles['edit-hint-line']}>
              {
                getFieldDecorator(key, {
                  initialValue: props.record[key] || '',
                  rules: [
                    { required: true, message: `请填入正确的${item[1]}` },
                  ],
                })(
                  buildFormItem(key, item)
                )
              }
            </div>
          </Form.Item>
        )
      })
    }
    <Form.Item>
      <Button htmlType="submit">添加</Button>
    </Form.Item>
  </Form>
}

const ShelfAddMachineForm = Form.create({ name: 'shelf_create' })(ShelfAddMachineFormInner)

const initFormData = () => {
  return FIELDS_LIST.reduce((result: any, current: any) => {
    result[current[0]] = ''
    return result
  }, {})
}

export default (props: Props) => {
  const [visible, onVisibleChange] = useState(false)
  const [loading, onLoadChange] = useState(false)
  const [formData, onSetFormData] = useState<any>({})

  const onSubmitCreate = (formData: any, resetForm: any) => {
    onLoadChange(true)
    shopAction.addShelfMachine(formData)
      .then(responseData => {
        message.info('添加货架机器成功')
        onLoadChange(false)
        onSetFormData({})
        resetForm(initFormData())
        listLoader.reloadListPage()
      })
      .catch((err) => {
        onLoadChange(false)
        message.warning(err.message)
      })
  }

  return (
    <div css={EditorStyles['edit-pane']}>
      <Button onClick={
        () => {
          onVisibleChange(true)
        }
      } size="small">{props.text}</Button>
      <Drawer
        title="添加机器"
        width={360}
        visible={visible}
        onClose={() => {
          onVisibleChange(false)
        }}
      >
        <div css={ViewerStyles['drawer-container']}>
          <Spin spinning={loading}>
            <ShelfAddMachineForm
              record={props.record}
              formData={formData}
              onSubmit={onSubmitCreate}
            />
          </Spin>
        </div>
      </Drawer>
    </div>
  )
}